import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Shell } from "./Shell";
import { FadeUp } from "./Sections";

const PILLARS = [
  {
    name: "Purpose-Driven Work",
    color: "#004778",
    text: "Apply your expertise to research and initiatives that create lasting, real-world impact.",
  },
  {
    name: "Collaborative Culture",
    color: "#7EBC37",
    text: "Work with multidisciplinary teams across research, policy, data, and community engagement.",
  },
  {
    name: "Growth & Opportunity",
    color: "#FFA100",
    text: "Develop your skills while contributing to solutions across a range of topics and project areas.",
  },
];

export default function Careers() {
  return (
    <Shell>
      <div data-testid="careers-page">
        <section className="mx-auto max-w-7xl px-6 pt-16 md:pt-24">
          <FadeUp>
            <p className="mb-5 flex items-center text-xs font-bold uppercase tracking-[0.18em] text-[#004778]">
              <span className="mr-2.5 inline-block h-2.5 w-2.5 bg-[#FFA100]" aria-hidden="true" />
              Careers at HARC
            </p>
            <h1 className="harc-heading max-w-3xl text-4xl font-medium leading-[1.1] tracking-tight text-[#004778] md:text-6xl">
              Do Work That Makes a Difference
            </h1>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#5C6B72] md:text-lg md:font-light">
              Join a mission-driven team using science, collaboration, and innovation to solve
              complex environmental challenges.
            </p>
          </FadeUp>
        </section>

        <section className="mx-auto max-w-7xl px-6 py-20 md:py-28" data-testid="careers-why">
          <FadeUp>
            <h2 className="harc-heading text-3xl font-medium text-[#004778] md:text-4xl">
              Why Work at HARC
            </h2>
          </FadeUp>
          <div className="mt-10 grid gap-5 md:grid-cols-3">
            {PILLARS.map((p, i) => (
              <FadeUp key={p.name} delay={i * 0.08}>
                <div
                  className="h-full border border-[#004778]/20 border-t-4 bg-white p-7"
                  style={{ borderTopColor: p.color }}
                  data-testid={`careers-pillar-${i + 1}`}
                >
                  <p className="harc-heading text-xl leading-snug text-[#022A42]">{p.name}</p>
                  <p className="mt-3 text-sm leading-relaxed text-[#5C6B72]">{p.text}</p>
                </div>
              </FadeUp>
            ))}
          </div>
        </section>

        <section className="bg-[#EEF3F5] py-20 md:py-28" data-testid="careers-openings">
          <div className="mx-auto max-w-7xl px-6">
            <FadeUp>
              <h2 className="harc-heading text-3xl font-medium text-[#004778] md:text-4xl">
                Current Openings
              </h2>
              <div className="mt-8 border border-[#004778]/25 bg-white p-8" data-testid="careers-openings-list">
                <p className="text-base leading-relaxed text-[#5C6B72]">
                  There are no open positions at this time.
                </p>
                <p className="mt-3 text-xs italic text-[#5C6B72]">
                  [HARC CONTENT REQUIRED: this section is updated as new opportunities become
                  available.]
                </p>
              </div>
              <Link
                to="/start-a-conversation"
                className="mockup-link-arrow mt-10"
                data-testid="careers-contact-cta"
              >
                Get in Touch <ArrowRight size={15} aria-hidden="true" />
              </Link>
            </FadeUp>
          </div>
        </section>
      </div>
    </Shell>
  );
}
